export default __webpack_public_path__ + "static/media/hms.e62e97cb.PNG";